import { useState } from "react";
import { Input, Button, HStack } from "@postenbring/hedwig-react";
import "./track.scss";

const DEFAULT_TRACKING_URL = "https://tracking.bring.com/tracking/";
const START_HTTPS_RX = /^[\s/]*(https?:\/\/)?/i;
const END_SLASH_RX = /[\s/]*$/;

// Use default URL if not set, enforce starting with 'https://' and ending with one slash
const normalizeUrl = (url) => {
    if (!(url || "").trim()) {
        url = DEFAULT_TRACKING_URL;
    }
    return url.replace(START_HTTPS_RX, "https://").replace(END_SLASH_RX, "/");
};

export const Track = ({
    label,
    formLabelColor,
    url,
    buttonLabel,
    placeholder,
    isEnglish,
    ariaLabel,
}) => {
    url = normalizeUrl(url);
    const [inputValue, setInputValue] = useState("");

    return (
        <form
            className={"kp-trace-form" + (formLabelColor ? " " + formLabelColor : "")}
            onSubmit={(e) => {
                e.preventDefault();
                const targetUrl = new URL(url);
                targetUrl.pathname += encodeURIComponent(inputValue.trim());
                if (isEnglish) {
                    targetUrl.searchParams.set("lang", "en");
                }
                window.location.href = targetUrl.toString();
            }}
        >
            <HStack gap="8" wrap>
                <Input
                    id="tracking-number"
                    label={label}
                    labelProps={{
                        className: "kp-trace-label",
                    }}
                    type="text"
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder={placeholder}
                    aria-label={ariaLabel}
                    autoComplete="off"
                    className="kp-trace-field"
                    data-color-scheme="light"
                />
                <Button type="submit" className="kp-trace-button">
                    {buttonLabel}
                </Button>
            </HStack>
        </form>
    );
};
